var consumer = {
  "units": {
    "Wh": {
      "single": "wattheure",
      "plural": "wattheures",
      "annotated_abv": "(Wh)",
      "abv": "Wh",
      "definition": "La production et la consommation d'énergie sont mesurées en wattheures (Wh). Un kilowattheure (kWh), qui vaut 1 000 wattheures, est l'unité communément utilisée par les fournisseurs d'électricité sur les factures mensuelles."
    },
    "kWh": {
      "single": "kilowattheure",
      "plural": "kilowattheures",
      "annotated_abv": "(kWh)",
      "abv": "kWh"
    },
    "MWh": {
      "single": "mégawattheure",
      "plural": "mégawattheures",
      "annotated_abv": "(MWh)",
      "abv": "MWh"
    },
    "GWh": {
      "single": "gigawatt-heure",
      "plural": "gigawatt-heures",
      "annotated_abv": "(GWh)",
      "abv": "GWh"
    },
    "TWh": {
      "single": "térawatt-heure",
      "plural": "térawatt-heures",
      "annotated_abv": "(TWh)",
      "abv": "TWh"
    },
    "PWh": {
      "single": "pétawatt-heure",
      "plural": "pétawatt-heures",
      "annotated_abv": "(PWh)",
      "abv": "PWh"
    },
    "EWh": {
      "single": "exawatt-heure",
      "plural": "exawatt-heures",
      "annotated_abv": "(EWh)",
      "abv": "EWh"
    },
    "ZWh": {
      "single": "zettawatt-heure",
      "plural": "zettawatt-heures",
      "annotated_abv": "(ZWh)",
      "abv": "ZWh"
    },
    "YWh": {
      "single": "yottawatt-heure",
      "plural": "yottawatt-heures",
      "annotated_abv": "(YWh)",
      "abv": "YWh"
    },
    "W": {
      "single": "watt",
      "plural": "watts",
      "annotated_abv": "(W)",
      "abv": "W"
    },
    "kW": {
      "single": "kilowatt",
      "plural": "kilowatts",
      "annotated_abv": "(kW)",
      "abv": "kW"
    },
    "MW": {
      "single": "mégawatt",
      "plural": "mégawatts",
      "annotated_abv": "(MW)",
      "abv": "MW"
    },
    "GW": {
      "single": "gigawatt",
      "plural": "gigawatts",
      "annotated_abv": "(GW)",
      "abv": "GW"
    },
    "TW": {
      "single": "térawatt",
      "plural": "térawatts",
      "annotated_abv": "(TW)",
      "abv": "TW"
    },
    "PW": {
      "single": "pétawatt",
      "plural": "pétawatts",
      "annotated_abv": "(PW)",
      "abv": "PW"
    },
    "EW": {
      "single": "exawatt",
      "plural": "exawatts",
      "annotated_abv": "(EW)",
      "abv": "EW"
    },
    "ZW": {
      "single": "zettawatt",
      "plural": "zettawatts",
      "annotated_abv": "(ZW)",
      "abv": "ZW"
    },
    "YW": {
      "single": "yottawatt",
      "plural": "yottawatts",
      "annotated_abv": "(YW)",
      "abv": "YW"
    },
    "percent": {
      "single": "pour cent",
      "plural": "pour cent",
      "annotated_abv": "%",
      "abv": "%"
    },
    "minutes": {
      "zero": "minutes",
      "ltone": "minute",
      "single": "minute",
      "plural": "minutes"
    },
    "hours": {
      "zero": "heures",
      "ltone": "heure",
      "single": "heure",
      "plural": "heures"
    },
    "months": {
      "zero": "mois",
      "ltone": "mois",
      "single": "mois",
      "plural": "mois"
    },
    "years": {
      "zero": "ans",
      "ltone": "an",
      "single": "an",
      "plural": "ans"
    },
    "days": {
      "zero": "jours",
      "ltone": "jour",
      "single": "jour",
      "plural": "jours"
    },
    "nights": {
      "zero": "nuits",
      "ltone": "nuit",
      "single": "nuit",
      "plural": "nuits"
    },
    "batteries": {
      "zero": "piles",
      "ltone": "pile",
      "single": "pile",
      "plural": "piles"
    },
    "trees": {
      "zero": "arbres",
      "ltone": "arbre",
      "single": "arbre",
      "plural": "arbres"
    },
    "kg": {
      "zero": "kg",
      "ltone": "kg",
      "single": "kg",
      "plural": "kgs"
    },
    "laps": {
      "zero": "tours",
      "ltone": "tour",
      "single": "tour",
      "plural": "tours"
    },
    "barrels": {
      "zero": "chemises",
      "ltone": "chemise",
      "single": "chemise",
      "plural": "chemises"
    },
    "flights": {
      "zero": "conflits",
      "ltone": "conflit",
      "single": "conflit",
      "plural": "conflits"
    },
    "launches": {
      "zero": "lancements",
      "ltone": "lancement",
      "single": "lancement",
      "plural": "lancements"
    }
  },
  "timeAgo": {
    "now": "Maintenant",
    "second": {
      "single": "Il y a 1 seconde",
      "plural": "Il y a %{number} secondes"
    },
    "minute": {
      "single": "Il y a 1 minute",
      "plural": "Il y a %{number} minutes"
    },
    "hour": {
      "single": "Il y a 1 heure",
      "plural": "Il y a %{number} heures"
    },
    "day": {
      "single": "Il y a 1 jour",
      "plural": "Il y a %{number} jours"
    },
    "week": {
      "single": "Il y a 1 semaine",
      "plural": "Il y a %{number} semaines"
    },
    "month": {
      "single": "Il y a 1 mois",
      "plural": "Il y a %{number} mois"
    },
    "year": {
      "single": "Il y a 1 an",
      "plural": "Il y a %{number} ans"
    }
  },
  "weather": {
    "unknown": "Météo inconnue",
    "footer": "Données météorologiques fournies par The Weather Company.",
    "credit": "Fourni par The Weather Company"
  },
  "reports": {
    "title": "Rapports",
    "submit": "Exécuter le rapport",
    "to": "vers",
    "selectDate": "Select the date",
    "insufficientData": "Veuillez revenir demain. Le cloud d’Enphase n’a pas collecté les données requises pour créer des rapports.",
    "1": {
      "name": "Production quotidienne",
      "title": "Production d'énergie du site",
      "description": "Récapitulatif de la production d'énergie quotidienne de ce site. Ce rapport fournit l'énergie par jour ; vous pouvez demander des jours jusqu'à la veille du jour courant."
    },
    "2": {
      "name": "Production récente",
      "title": "Production récente d'électricité du site",
      "description": "Récapitulatif de la dernière semaine de production d'énergie en incréments de 5 minutes de ce site."
    },
    "6": {
      "name": "Production mensuelle",
      "title": "Production mensuelle d’énergie",
      "description": "Récapitulatif d'un mois de production d'énergie et puissance maximum de ce site."
    },
    "15": {
      "name": "Consommation quotidienne",
      "title": "Consommation d'énergie du site",
      "description": "Récapitulatif de la consommation d'énergie quotidienne de ce site. Ce rapport fournit l'énergie par jour ; vous pouvez demander des jours jusqu'à la veille du jour courant."
    },
    "16": {
      "name": "Consommation récente",
      "title": "Consommation récente d'électricité du site",
      "description": "Récapitulatif de la dernière semaine de consommation d'énergie de ce site, en incréments de 15 minutes."
    },
    "17": {
      "name": "Énergie nette mensuelle",
      "title": "Énergie nette mensuelle",
      "description": "Ce rapport récapitule la production et la consommation d'énergie de ce site, ainsi que l'importation d'énergie vers ce site et l'exportation d'énergie depuis ce site, toutes les 15 minutes du mois sélectionné. Si le système comporte des batteries C.A., le rapport montre également l'énergie stockée et déchargée."
    },
    "19": {
      "name": "Rapport sur la batterie",
      "title": "Rapport sur la batterie",
      "description": "Ce rapport contient les données relatives à la batterie collectées au cours des 7 derniers jours."
    },
    "3": {
      "name": "Production d'énergie en un jour par module",
      "title": "Production d'énergie en un jour par module",
      "description": "Ce rapport fournit la production d'énergie de tous les micro-onduleurs pour la date indiquée."
    },
    "5": {
      "name": "Production d'énergie en un mois par module",
      "title": "Production d'énergie en un mois par module",
      "description": "Ce rapport fournit la production d'énergie de tous les micro-onduleurs pour le mois indiqué."
    },
    "20": {
      "name": "Rapport d’autotest d’IQ-Relay",
      "title": "Rapport des résultats de l’autotest d’IQ-Relay",
      "description": "Ce rapport fournit les derniers résultats des autotests d’IQ-Relay"
    },
    "25": {
      "name": "Rapport personnalisé (en Wh)",
      "title": "Rapport personnalisé",
      "description": ""
    }
  },
  "stats": {
    "total": "Énergie totale",
    "peak_production": "Puissance de crête",
    "latest_production": "Puissance la plus récente",
    "peak_consumption": "Pic de consommation",
    "latest_consumption": "Dernière consommation",
    "recent_power": "Puissance récente",
    "maintainer": "Contactez votre mainteneur",
    "enphase": "Contacter l'assistance Enphase",
    "orenphase": "Ou contacter l'assistance Enphase",
    "learn_more": "En savoir plus.",
    "where": "Où se situe le problème ?",
    "toGrid": "Environ %{value} exportés vers le réseau",
    "fromGrid": "Environ %{value} importés à partir du réseau",
    "normal": {
      "title": "Normal",
      "modal": "Votre système fonctionne normalement."
    },
    "shortcomm": {
      "title": "La passerelle ne génère pas de rapport",
      "hours": "Votre système n’a pas transmis de données au cloud d’Enphase au cours des dernières %{hours} heures.",
      "date": "Votre système n’a pas transmis de données au cloud d’Enphase depuis le %{date}.",
      "unknown": "Ce système ne transmet pas de données au cloud d’Enphase.",
      "question": "Votre connexion Internet est-elle arrêtée ?",
      "help_topic_link": "Reconnectez-vous pour connaître les performances de votre système.",
      "link": "Cliquez ici pour obtenir de l'aide."
    },
    "meter": {
      "title": "Le compteur ne génère pas de rapport",
      "hours": "Le compteur de votre système n’a pas renvoyé de rapport à la passerelle depuis %{hours} heures.",
      "date": "Le compteur de votre système n’a pas renvoyé de rapport à la passerelle depuis %{date}.",
      "ct_wiring": "Il y a un problème avec les mesures du compteur de votre passerelle. Contacter votre mainteneur pour obtenir de l’aide.",
      "unknown": "Le compteur de votre système ne renvoie pas de rapport à la passerelle.",
      "link": "Cliquez ici pour obtenir de l'aide.",
      "modal": "Votre compteur n’a renvoyé aucune donnée à la passerelle depuis"
    },
    "meter_issue": {
      "title": "Problème de compteur",
      "ct_wiring": "Il y a un problème avec les mesures du compteur de votre Envoy.",
      "link": "Cliquez ici pour obtenir de l'aide."
    },
    "battery": {
      "title": "Des batteries C.A. ne génèrent pas de données.",
      "modal": "Cette batterie C.A. ne génère aucune donnée.",
      "message": "Certaines batteries C.A. ne génèrent pas de données.",
      "messageSome": "Certaines batteries C.A. (%{count}) ne génèrent pas de données.",
      "link": "Cliquez ici pour obtenir de l'aide."
    },
    "storage_idle": {
      "title": "Stockage inactif",
      "modal": "Cette batterie C.A. ne se charge pas ou ne se décharge pas.",
      "date": "Au moins une batterie C.A. n'a pas été chargée ou déchargée depuis le %{date}.",
      "unknown": "Au moins une batterie C.A. ne charge pas ou ne se décharge pas.",
      "link": "Cliquez ici pour obtenir de l'aide."
    },
    "encharge": {
      "title": "La batterie ne génère pas de rapport",
      "modal": "Cette batterie ne génère aucune donnée.",
      "message": "La batterie ne génère aucune donnée. Cela peut se produire si la communication sans fil entre votre passerelle et la batterie est faible. Il peut s’agir d’une défaillance temporaire qui se rétablira bientôt.",
      "requestMaintainer": "Si le problème persiste, demandez de l’aide à votre technicien de maintenance.",
      "messageSome": "Certaines batteries (%{count}) ne renvoient pas de données.",
      "link": "Cliquez ici pour obtenir de l'aide."
    },
    "enpower": {
      "title": "Le contrôleur du système ne génère pas de rapport",
      "modal": "Ce contrôleur du système ne génère aucune donnée.",
      "message": "Le contrôleur du système ne génère aucune donnée. Cela peut se produire si la communication sans fil entre votre passerelle et le contrôleur du système est faible. Il peut s’agir d’une défaillance temporaire qui se rétablira bientôt.",
      "requestMaintainer": "Si le problème persiste, demandez de l’aide à votre technicien de maintenance.",
      "messageSome": "Certains contrôleurs du système (%{count}) ne renvoient pas de données.",
      "link": "Cliquez ici pour obtenir de l'aide."
    },
    "encharge_issue": {
      "title": "Erreur de la batterie",
      "modal": "Cette batterie comporte une erreur.",
      "message": "La batterie comporte une erreur."
    },
    "enpower_issue": {
      "title": "Erreur du contrôleur du système",
      "modal": "Ce contrôleur du système comporte une erreur.",
      "message": "Le contrôleur du système comporte une erreur."
    },
    "micro": {
      "title": "Les micro-onduleurs ne génèrent pas de rapport",
      "modal": "Ce micro-onduleur ne renvoie aucune donnée à la passerelle.",
      "message": "Certains micro-onduleurs ne renvoient pas de données à la passerelle.",
      "messageSome": "Certains micro-onduleurs (%{count}) ne renvoient pas de données à la passerelle.",
      "messageAll": "Aucun micro-onduleur ne renvoie de données à la passerelle.",
      "link": "Cliquez ici pour obtenir de l'aide."
    },
    "power": {
      "title": "Problème de production système",
      "message": "Il y a un problème de production avec votre système.",
      "messageSome": "Le micro-onduleur génère un problème de production.",
      "messageThreshold": "Votre système produit moins d'énergie qu'attendue.",
      "link": "Contacter l'assistance Enphase pour obtenir de l'aide.",
      "maintainerlink": "Contacter votre mainteneur pour obtenir de l'aide."
    }
  }
};
module.exports = consumer;